import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import { downloadFile } from "../../helpers/request";
import { addAlert } from "../../store/alertSlice/alertSlice";

const AutoDownloader = ({ fileUrl, hideText = false, errorText = 'Download failed' }) => {
  const [secondsLeft, setSeconds] = useState(3);
  const dispatch = useDispatch();

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (secondsLeft === 0) {
        downloadFile(fileUrl)
          .catch(() => {
            dispatch(addAlert({
              text: errorText,
              severity: 'error',
            }));
          })
        clearInterval(timerId);
        return;
      }
      setSeconds(secondsLeft - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [secondsLeft]);

  return hideText ? null : (
    <Typography variant='body1'>Download should begin shortly{new Array(4 - secondsLeft).join('.')}</Typography>
  )
}

export default AutoDownloader;